/* eslint-disable */
const de = {
  message: {
    location: 'Standort',
    experience: 'Erfahrung',
    education: 'Ausbildung',
    skills: 'Skills',
    languages: 'Sprachen',
    portfolio: 'Portfolio',
    honors: 'Auszeichnungen',
    about: 'Über mich',
    external: 'Extern',
    contact: 'Kontakt'
  },
}
export default de
